import { render, staticRenderFns } from "./SignUpWizard.vue?vue&type=template&id=86777fd4&scoped=true"
import script from "./SignUpWizard.vue?vue&type=script&lang=js"
export * from "./SignUpWizard.vue?vue&type=script&lang=js"
import style0 from "./SignUpWizard.vue?vue&type=style&index=0&id=86777fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86777fd4",
  null
  
)

export default component.exports